import React from 'react'
import styles from "./SearchField.module.scss"

const LeftSearchBar = (props) => {
    return (
        <div>
            <input className={styles.search}
                onChange={props?.onChange}
                placeholder={props?.placeholder}
                // onBlur={props?.onBlur}
                value={props?.value}
            />
        </div>
    )
}

export default LeftSearchBar